import React, {PureComponent} from "react"
import styled from "styled-components"

import {Grid as GridBase, Row, Col} from "react-bootstrap"
import {Sidebar, Detail} from "@irati-web/reward/src/components/CustomReward"
import {rewardTracking} from "@irati-tracking/reward"
import Layout from "@irati-web/recognition/src/components/Layout"
import bannerImg from "@irati-web/recognition/src/images/banner.png"
import {injectIntl} from "@irati/utils/lang"

const Grid = styled(GridBase)`
  margin-top: -200px;
`

class CustomReward extends PureComponent {
  componentDidMount() {
    rewardTracking.rewardsTabViewCustomRewardDetails()
  }

  render() {
    return (
      <Layout bannerImg={bannerImg}>
        <Grid>
          <Row>
            <Col md={8} sm={12}>
              <Detail />
            </Col>
            <Col md={4}>
              <Sidebar />
            </Col>
          </Row>
        </Grid>
      </Layout>
    )
  }
}

export default injectIntl(CustomReward)
